import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconSearch = createIcon({
  viewBox: '0 0 40 40',
  path: (
    <>
      <path
        d="M20.0001 38.5714C30.2569 38.5714 38.5716 30.2567 38.5716 20C38.5716 9.7433 30.2569 1.42859 20.0001 1.42859C9.74342 1.42859 1.42871 9.7433 1.42871 20C1.42871 30.2567 9.74342 38.5714 20.0001 38.5714Z"
        stroke="#CFDAEC"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.4583 27.4846L24.3368 23.3631C25.6413 21.9947 26.4422 20.1419 26.4422 18.1021C26.4422 13.8904 23.028 10.4762 18.8163 10.4762C14.6047 10.4762 11.1904 13.8904 11.1904 18.1021C11.1904 22.3138 14.6047 25.728 18.8163 25.728C20.1197 25.728 21.3466 25.401 22.4197 24.8246L26.769 29.1739C27.2355 29.6404 27.9918 29.6404 28.4583 29.1739C28.9248 28.7075 28.9248 27.9511 28.4583 27.4846ZM24.1313 18.1021C24.1313 21.0375 21.7517 23.4171 18.8163 23.4171C15.8809 23.4171 13.5013 21.0375 13.5013 18.1021C13.5013 15.1667 15.8809 12.7871 18.8163 12.7871C21.7517 12.7871 24.1313 15.1667 24.1313 18.1021Z"
        fill="#1E2B37"
      />
      <mask
        id="mask0_1255_79202"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="11"
        y="10"
        width="18"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.4583 27.4846L24.3368 23.3631C25.6413 21.9947 26.4422 20.1419 26.4422 18.1021C26.4422 13.8904 23.028 10.4762 18.8163 10.4762C14.6047 10.4762 11.1904 13.8904 11.1904 18.1021C11.1904 22.3138 14.6047 25.728 18.8163 25.728C20.1197 25.728 21.3466 25.401 22.4197 24.8246L26.769 29.1739C27.2355 29.6404 27.9918 29.6404 28.4583 29.1739C28.9248 28.7075 28.9248 27.9511 28.4583 27.4846ZM24.1313 18.1021C24.1313 21.0375 21.7517 23.4171 18.8163 23.4171C15.8809 23.4171 13.5013 21.0375 13.5013 18.1021C13.5013 15.1667 15.8809 12.7871 18.8163 12.7871C21.7517 12.7871 24.1313 15.1667 24.1313 18.1021Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1255_79202)">
        <rect
          x="-18.0957"
          y="-19.9932"
          width="76.1905"
          height="76.1905"
          fill="#1E2B37"
        />
      </g>
    </>
  ),
});

export default IconSearch;
